// Shared facts for the Terms and Privacy pages so they can never drift apart.
export const LEGAL_ENTITY = 'Mermadic Solutions, LLC';
export const LEGAL_ENTITY_LONG = 'Mermadic Solutions, LLC, a Delaware limited liability company';
export const SUPPORT_EMAIL = 'help@mermadicsolutions.com';
export const GOVERNING_LAW = 'the State of Delaware, United States';
export const LAST_UPDATED = 'August 12, 2026';
